export const errorMessages = {
  SOMETHING_WRONG: "Something went wrong",
  toDateMustBeGreaterThanToDate: "To date must be greater than from date",
  FromTimeShouldBeLessThanToTime:
    "From time should be less than to time on the same date",
  EnterValidTimeRange: "Please enter valid time range",
  NO_ACCOUNT_FOUND: "No Account Found.",
  NO_DATA_FOUND: "No Data Found."
};
